module.exports = __webpack_public_path__ + "static/media/omzchat.e9a6acf7.svg";